module.exports = __webpack_public_path__ + "img/header-navigation-below-mitsu.e1fb865a.png";